/**
 * Persistencia local de uso y favoritos de intents.
 * Sirve para ordenar las acciones sugeridas por frecuencia real y para que
 * el usuario fije sus favoritas (sección 7.4 de la propuesta). Es solo una
 * señal de UX en el cliente; la telemetría formal del composer llega en Fase 2.
 */

const USAGE_KEY = 'palacete-intent-usage';
const FAVORITES_KEY = 'palacete-intent-favorites';

type UsageMap = Record<string, number>;

function read<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

function write(key: string, value: unknown) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* almacenamiento no disponible — degradar en silencio */
  }
}

export function getUsage(): UsageMap {
  return read<UsageMap>(USAGE_KEY, {});
}

export function recordIntentUse(id: string): UsageMap {
  const usage = getUsage();
  usage[id] = (usage[id] ?? 0) + 1;
  write(USAGE_KEY, usage);
  return usage;
}

export function getFavorites(): string[] {
  return read<string[]>(FAVORITES_KEY, []);
}

export function toggleFavorite(id: string): string[] {
  const current = getFavorites();
  const next = current.includes(id) ? current.filter((item) => item !== id) : [...current, id];
  write(FAVORITES_KEY, next);
  return next;
}
